module.exports = __webpack_public_path__ + "static/media/two_triangle_xie.29ac5468.svg";